import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { FuseConfigService } from '@fuse/services/config.service';
import { fuseAnimations } from '@fuse/animations';

//SERVICE
import { ForAllService } from "../services/forall.service";
import { MatSnackBar } from "@angular/material/snack-bar";

///IDIOMAS
import { lang_certificar } from 'app/idiomas/i18n/certificar/certificar.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector     : 'native',
    templateUrl  : './native.component.html',
    styleUrls    : ['./native.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations   : fuseAnimations
})
export class NativeComponent {
      displayedColumns = ['practice', 'description', 'statement1', 'statement2'];
      dataSource :any;

      numPractices : number;
      statement1 : string;
      statement2 : string;
      nombreEmpresa: string;
      statement1Part1: string;
      statement1Part2: string;
      statement2Part1: string;
      statement2Part2: string;

  constructor(
    private forallService: ForAllService,
    public snackBar: MatSnackBar,
    private translate: TranslateService,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService) {

    this.getParams();
    lang_certificar.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });
  }

  private updateText(event,idtxt,posicion){

    if(event.target.value.length >= 1){

        //Do you know or have you participated in $replace1 in your workplace?
        this.dataSource.find(x=>x.position == posicion).statement1 = this.statement1.replace('$replace1',event.target.value);

        this.dataSource.find(x=>x.position == posicion).practice = event.target.value;

        //Do you think $replace1 is a good initiative at $replace2?
        //this.dataSource.find(x=>x.position == posicion).statement2 =
        //this.statement2.replace('$replace1',event.target.value).replace('$replace2',this.nombreEmpresa);
        this.dataSource.find(x=>x.position == posicion).statement2 = this.statement2.replace('$replace1',event.target.value)
          .replace('$replace2',this.nombreEmpresa);

    }

  }

  private onBlurPractica(event,idtxt,posicion){

    if(event.target.value.length >= 1){
        let data = {
          "fechaCertificar": localStorage.getItem('fechaProducto'),
          "orden": posicion,
          "practicaForall":  event.target.value,
          "statement1":  this.statement1.replace('$replace1',event.target.value),
          "statement2":  this.statement2.replace('$replace1',event.target.value).replace('$replace2',this.nombreEmpresa)
          };

         this.forallService.registerForall(data)
          .subscribe(response => {

            if(response['message'] == 'Success'){
              this.openSuccessSnackBar(this.translate.instant('CERTIFICAR.FORALL.MSJ_PRACTICEREGISTERED'),this.translate.instant('ALERTS.OK'));
              //this.openSuccessSnackBar('Practice saved succesfully','OK');
            }

            }, error => {
              console.log(error);
        });
    }
  }



  private onBlurDescripcion(event,idtxt,posicion){
    if(event.target.value.length >= 1){

        let data = {
              "fechaCertificar": localStorage.getItem('fechaProducto'),
              "orden": posicion,
              "descripcionForall":  event.target.value
              };

       this.forallService.registerForall(data)
        .subscribe(response => {

          if(response['message'] == 'Success'){
            this.openSuccessSnackBar(this.translate.instant('CERTIFICAR.FORALL.MSJ_DESCRIPTIONREGISTERED'),this.translate.instant('ALERTS.OK'));

          }

          }, error => {
            console.log(error);
          });
      }
  }

  private getParams(){
  let data = {"fechaCertificar": localStorage.getItem('fechaProducto')};

    this.forallService.getParams(data)
    .subscribe(response => {


      this.numPractices = response['objeto']['numPracticas'];
      this.statement1 = response['objeto']['statement1Nativo'];
      this.statement2 = response['objeto']['statement2Nativo'];
      this.nombreEmpresa = response['empresa'];

      var splitted1 = response['objeto']['statement1Nativo'].split("$replace1");
      var splitted2 = response['objeto']['statement2Nativo'].split("$replace1");

      this.statement1Part1 = splitted1[0];
      this.statement1Part2 = splitted1[1];
      this.statement2Part1 = splitted2[0];
      this.statement2Part2 = splitted2[1].replace("$replace2","");

      this.getPracticesSaved();

    }, error => {
      console.log("error", error);
    });
  }

  private getPracticesSaved(){
    let data = {"fechaCertificar": localStorage.getItem('fechaProducto')};

    this.forallService.getPracticesSaved(data)
      .subscribe(response => {

      let status = response['message'];
      let res = [];

      if(status == 201){

          for (let i = 0; i < this.numPractices; i++) {
              res.push(
                  {position: i,
                    practice: '',
                    description: '',
                    statement1: '',
                    statement2: '',
                    statement1Part1: this.statement1Part1,
                    statement1Part2: this.statement1Part2,
                    statement2Part1: this.statement2Part1,
                    statement2Part2: this.statement2Part2
                  });
              }
          this.dataSource = res;
      }else{


          for (let i = 0; i < response['practicas'].length; i++) {

            res.push(
                {position: response['practicas'][i]['orden'],
                  practice: response['practicas'][i].hasOwnProperty('practicaForall') ?
                              response['practicas'][i]['practicaForall'] : '',
                  description: response['practicas'][i].hasOwnProperty('descripcionForall') ?
                                response['practicas'][i]['descripcionForall'] : '',
                  statement1: response['practicas'][i]['statement1'],
                  statement2: response['practicas'][i]['statement2'],
                  statement1Part1: this.statement1Part1,
                  statement1Part2: this.statement1Part2,
                  statement2Part1: this.statement2Part1,
                  statement2Part2: this.statement2Part2
                });

          }

          if(this.numPractices > response['practicas'].length){

            let total = response['practicas'].length;
            let responseRest = (this.numPractices - total);

            for (let i = 0; i < responseRest; i++) {
                    total = total +1 ;
            res.push(
                {position: total,
                  practice: '',
                  description: '',
                  statement1: '',
                  statement2: '',
                  statement1Part1: this.statement1Part1,
                  statement1Part2: this.statement1Part2,
                  statement2Part1: this.statement2Part1,
                  statement2Part2: this.statement2Part2
                });
            }
          }
          this.dataSource = res;
      }

    }, error => {
      console.log("error", error);
    })

  }

  openErrorSnackBar(message: string, action: string) {
      this.snackBar.open(message, action, {
         duration: 5000,
         verticalPosition: 'top',
         panelClass: ['background-red']
      });
   }


   openSuccessSnackBar(message: string, action: string) {
      this.snackBar.open(message, action, {
         duration: 5000,
         verticalPosition: 'top',
         panelClass: ['background-success']
      });
   }

}
